module.exports = __webpack_public_path__ + "images/psp/SizeGuide/updated/medium-self-10x10-100x800.svg";